import React, { useContext } from 'react';
import { OrderDetail } from '~/types/Order';
import { voidOrder } from '../../../../api';
import { useNavigate } from 'react-router-dom';
import { CartActionContext } from '~/App/Layout/providers/CartProvider';
import { OrderContext } from '~/App/Layout/providers/OrderProvider';
import { DeleteOutlined } from '@ant-design/icons';
import i18n from '~/i18n';
import message from '~/utils/message';
import useNeedAuth from '../../../../../AuthorizePanel/hooks';
import { Order } from '@restaurant/api';

const useVoidButton = ({ order }: { order: Order }) => {
  const needAuth = useNeedAuth();
  const { order: currentOrder, newOrder } = useContext(OrderContext);
  const navigate = useNavigate();
  const { resetCart } = useContext(CartActionContext);

  const onClick = () => {
    needAuth({
      permissionName: 'orderVoidAuthorization:r',
      entityId: order.orderId,
      onSubmit: ({ userId, actionToken }) => {
        voidOrder({
          level: 'order',
          orderId: order.orderId,
          voidBy: userId,
          actionToken,
        }).then(({ error }) => {
          if (error) {
            message.error(error);
            return;
          }
          if (!currentOrder.isNew && currentOrder.orderId === order.orderId) {
            newOrder();
            resetCart();
          }
          message.warning(i18n.t('message_success_void_order'));
          navigate('../', { replace: true });
        });
      },
    });
  };

  return {
    key: 'void',
    text: i18n.t('bottom_bar_void'),
    icon: <DeleteOutlined />,
    onClick,
  };
};

export default useVoidButton;
